import React from "react";
import "./footer.css";
import { useSelector } from "react-redux";

function Footer() {
  const { data } = useSelector((state) => state.product);
  return (
    <div className="footer">
      <div className="contact-info">
        <span>Contact Us:</span>
        <span>
          Email:
          <a href="mailto:{data.customerSupport && data.customerSupport[0].supportEmailAddress ? data.customerSupport[0].supportEmailAddress : ''}">
            {data.customerSupport && data.customerSupport[0].supportEmailAddress
              ? data.customerSupport[0].supportEmailAddress
              : ""}
          </a>
        </span>
        <span>
          Phone: <span className="tel">
          {data.customerSupport && data.customerSupport[0].supportMobileNumber
              ? data.customerSupport[0].supportMobileNumber
              : ""}
          </span>
        </span>
      </div>
      <p className="copyright">
        &copy; 2023 {data.businessName}. All rights reserved.
      </p>
    </div>
  );
}

export default Footer;
